import clsx from 'clsx';
import { flow } from 'lodash';
import React, { FunctionComponent, useMemo } from 'react';
import { useCallback } from 'react';
import { useState } from 'react';
import { Customer } from '../../../../../types/entities';
import { ArrowDownIcon } from '../../../../Icons';
import styles from './CustomerPurchaseTab.module.scss';
import {
    ActiveTabsCustomer,
    CustomerPurchaseTabProps,
} from './CustomerPurchaseTab.type';
import { getTemplateConfig } from '../../../../Purchases/hooks/getTemplateConfig';
import StubAuthRequired from '../../../../Purchases/components/StubAuthRequired';

const CustomerPurchaseTab: FunctionComponent<CustomerPurchaseTabProps> = ({
    purchase,
}) => {
    const [activeTabs, setActiveTabs] = useState<
        CustomerPurchaseTabProps['activeTabs']
    >({
        customers: purchase?.customers?.map((_: Customer) => ({
            isTabActive: true,
        })),
    });
    const isInfoRestricted = useMemo(
        () => getTemplateConfig(purchase).publicAnnounceTabCustomer?.isHidden,
        [purchase]
    );

    const toggleList = useCallback(
        (toggledItemIdx?: number) => {
            const newActiveTabs = {
                customers: activeTabs?.customers?.map(
                    (customer: ActiveTabsCustomer, customerIdx: number) => ({
                        isTabActive:
                            customerIdx === toggledItemIdx
                                ? !customer.isTabActive
                                : customer.isTabActive,
                    })
                ),
            };
            setActiveTabs(newActiveTabs);
        },
        [activeTabs]
    );

    const listElement = useCallback((title: string | any, definition: any) => {
        if (!title) {
            return null;
        }
        return (
            <>
                <dt key={title}>{title}</dt>
                <dd key={definition}>
                    {definition === null ||
                    definition === undefined ||
                    definition === ''
                        ? '-'
                        : definition}
                </dd>
            </>
        );
    }, []);
    return isInfoRestricted ? (
        <StubAuthRequired />
    ) : (
        <div className={styles.container}>
            <div className={styles.content}>
                {purchase?.customers?.map(
                    (customer: Customer, customerIdx: number) => {
                        const isTabActive =
                            activeTabs?.customers?.[customerIdx]?.isTabActive;
                        return (
                            <div
                                // eslint-disable-next-line react/no-array-index-key
                                key={`${customer?.shortName}-${customerIdx}`}
                                className={clsx(
                                    styles.item,
                                    isTabActive && styles.active
                                )}
                            >
                                <div
                                    className={styles.lotTitle}
                                    onClick={() => toggleList(customerIdx)}
                                >
                                    <ArrowDownIcon className={styles.icon} />
                                    {`«${customer?.shortName}»`}
                                </div>
                                {isTabActive && (
                                    <div className={styles.itemHidden}>
                                        <dl className={styles.listElements}>
                                            {listElement('ИНН', customer?.inn)}
                                            {listElement(
                                                'Юридический адрес',
                                                customer?.legalAddress
                                            )}
                                        </dl>
                                    </div>
                                )}
                            </div>
                        );
                    }
                )}
                <h3>Контактные лица</h3>
                <ol className={styles.list}>
                    {purchase?.contacts?.map((contact: any) => {
                        return (
                            <li key={contact?.id}>
                                <h4>{contact?.name}</h4>
                                <dl className={styles.listElements}>
                                    {listElement('Телефон', contact?.phone)}
                                    {listElement('Email', contact?.email)}
                                    {listElement(
                                        'Мобильный телефон',
                                        contact?.mobilePhone
                                    )}
                                    {listElement(
                                        'Должность',
                                        contact?.position
                                    )}
                                    {listElement(
                                        'Круг вопросов',
                                        contact?.questions
                                    )}
                                </dl>
                            </li>
                        );
                    })}
                </ol>
            </div>
        </div>
    );
};

export default flow(() => CustomerPurchaseTab)();
